import { Button } from 'antd';
import styled from 'styled-components';

export const StyledCallCounter = styled.div`
  background: rgba(41, 80, 243, 0.1);
  border-radius: 4px;
  min-width: 250px;
  text-align: center;
  color: #4385f5;
  padding: 6px;
  font-size: 14px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 250px;
  @media only screen and (max-width: 768px) {
    min-width: 100%;
  }
  .anticon {
    height: 22px;
  }
`;
